export default "__VITE_ASSET__DWwW$Q2z__"